import utils from '@/utils'

const LIST_PARAMS_KEY = 'classroomSchedule:listParams'

export const classroomSchedule = {
  namespaced: true,
  state: {
    list: {
      data: [],
      meta: {},
    },
    listLoading: false,
    detail: {},
    detailLoading: false,
    deleteLoading: false,
    listParams: JSON.parse(localStorage.getItem(LIST_PARAMS_KEY)),
  },
  getters: {
    list: (state) => {
      return state.list
    },
    detail: (state) => {
      return state.detail
    },
    isListLoading: (state) => {
      return state.listLoading
    },
    isDetailLoading: (state) => {
      return state.detailLoading
    },
    isDeleteLoading: (state) => {
      return state.deleteLoading
    },
    listParams: (state) => {
      return state.listParams
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data
    },
    setDetail(state, data) {
      state.detail = data
    },
    setListLoading(state, data) {
      state.listLoading = data
    },
    setDetailLoading(state, data) {
      state.detailLoading = data
    },
    setDeleteLoading(state, data) {
      state.deleteLoading = data
    },
    setListParams(state, data) {
      localStorage.setItem(LIST_PARAMS_KEY, JSON.stringify(data))
    },
  },
  actions: {
    async getList({ commit, dispatch }, filters) {
      commit('setListLoading', true)
      try {
        const response = await axios.get(`/api/classroom-schedules`, {
          params: filters,
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroomSchedule/getList', error },
          { root: true }
        )
      } finally {
        commit('setListLoading', false)
      }
    },
    async getDetail({ commit, dispatch }, id) {
      commit('setDetailLoading', true)
      try {
        const response = await axios.get(`/api/classroom-schedules/${id}`)
        commit('setDetail', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroomSchedule/getDetail', error },
          { root: true }
        )
      } finally {
        commit('setDetailLoading', false)
      }
    },
    async create({ commit, dispatch }, data) {
      commit('setDetailLoading', true)
      let err = null
      try {
        const response = await axios.post('/api/classroom-schedules', data)
        commit('setDetail', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroomSchedule/create', error },
          { root: true }
        )
        err = error
      } finally {
        commit('setDetailLoading', false)
      }
      return err
    },
    async update({ commit, dispatch }, data) {
      commit('setDetailLoading', true)
      let err = null
      try {
        const response = await axios.put(
          `/api/classroom-schedules/${data.id}`,
          data
        )
        commit('setDetail', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroomSchedule/update', error },
          { root: true }
        )
        err = error
      } finally {
        commit('setDetailLoading', false)
      }
      return err
    },
    async delete({ commit, dispatch }, id) {
      commit('setDeleteLoading', true)
      let err = null
      try {
        await axios.delete(`/api/classroom-schedules/${id}`)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroomSchedule/delete', error },
          { root: true }
        )
        err = error
      } finally {
        commit('setDeleteLoading', false)
      }
      return err
    },
  },
}
